import '@/components/AppBar/init';
import AppBar from './AppBar';

const GlobalComponents = {
  install(Vue) {
    Vue.component('AppBar', AppBar);
  },
};

export default GlobalComponents;
